module.exports = __webpack_public_path__ + "static/media/560.d43ea4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/560.png
// module id = 770
// module chunks = 0